export const ChartSettingsDefaults = {
    generalSettings: {
        chart: {
            lineColor: {
                value: "#2780E3"
            },
            sideColor: {
                value: "#2e2f2f"
            },
            upColor: {
                value: "#2780E3"
            },
            downColor: {
                value: "#ff0039"
            },
            barChange: {
                value: false
            },
            semiLogAxis: {
                value: false
            },
            volumeColor: {
                value: "#2780E3"
            },
            upColorVolume: {
                value: "#2780E3"
            },
            downColorVolume: {
                value: "#ff0039"
            },
            barChangeVolume: {
                value: true
            },
            obvColor: {
                value: "#2e2f2f"
            }
        },
        crossHair: {
            enabled: {
                value: true
            },
            lineColor: {
                value: "#b4b4b9"
            },
            boxColor: {
                value: "#48484a"
            },
            textColor: {
                value: "#ffffff"
            }
        },
        marker: {
            enabled: {
                value: true
            }, lineColor: {
                value: "#b4b4b9"
            },
        },
        misc: {
            hidePopup: {
                value: false
            }
        },
    }
}



export const IndicatorSettingsDefaults = {
    indicatorSettings: {
        single: {
            parabolicSar: {
                start: 0.02,
                inc: 0.02,
                max: 0.2,
                color: "#2780e3",
                lineWidth: 2
            },
            macd: {
                fast: 12,
                slow: 26,
                smooth: 9,
                macdColor: "#2780e3",
                signalColor: "#ff7518",
                histColor: "#9954bb",
                histWidth: 4,
                macdWidth: 1,
                signalWidth: 1,
            },
            relativeStrengthIndex: {
                length: 14,
                color: "#2780e3",
                lineWidth: 0.75,
                bandColor: "#aaa",
                backColor: "#9b9ba316",
                upper: 70,
                lower: 30
            },
            rsRating: {
                length: 14,
                color: "#0000ff",
                lineWidth: 1
            },
            stochasticOscillator: {
                param_k: 14,
                param_d: 3,
                smooth: 3,
                kColor: "#3782f2",
                dColor: "#f48709",
                lineWidth: 0.75,
                bandColor: "#ddd",
                backColor: "#381e9c16",
                upper: 80,
                lower: 20
            },
            stochasticRsi: {
                rsiLen: 14,
                stochLen: 14,
                kSmooth: 3,
                dSmooth: 3,
                kColor: "#3782f2",
                dColor: "#f48709",
                lineWidth: 0.75,
                bandColor: "#ddd",
                backColor: "#381e9c16",
                upper: 80,
                lower: 20
            },
            williamsR: {
                length: 14,
                color: "#ff7518",
                lineWidth: 0.75,
                bandColor: "#aaa",
                backColor: "#9b9ba316",
                upper: -20,
                lower: -80
            },
            trendChannels: {
                period: 21,
                color: "#2780E3",
                lineWidth: 1,
                bandColor: "rgba(39, 128, 227, 0.1)"
            },
            bollingerBands: {
                length: 21,
                stddev: 2,
                lineWidth: 1,
                basicLineGroup: {
                    basicLineEnable: true,
                    basicColor: "#D75800",
                },
                upperLineGroup: {
                    upperLineEnable: true,
                    upperColor: "#2A9044",
                },
                lowerLineGroup: {
                    lowerLineEnable: true,
                    lowerColor: "#FF0039",
                },
                backgroundGroup: {
                    backgroundEnable: true,
                    backgroundColor: "#d7580026",
                }
            },
            averageTrueRange: {
                length: 14,
                color: "#165ba8",
                lineWidth: 1,
                multiplier: 1
            },
            relativeVolatilityMeasure: {
                length: 15,
                color: "#165ba8",
                lineWidth: 2,
                backColor: '#15d822',
                backColor1: '#25d6ee',
            },
            averageDailyRangePercent: {
                length: 20,
                color: "#165ba8",
                lineWidth: 2
            },
            rateOfChange: {
                length: 10,
                color: "#2780e3",
                lineWidth: 1
            },
            valueTraded: {
                color: "#2780e3",
                lineWidth: 1
            },
            vwap: {
                color: "#2780e3",
                lineWidth: 1
            },
        },
        additional: {
            CMO: {
                length: 14,
                lineWidth: 0.75,
                color: '#559de0'
            },
            ALMA: {
                length: 9,
                offset: 0.85,
                sigma: 6,
                lineWidth: 0.75,
                color: '#559de0'
            },
            ATRp: {
                length: 14,
                lineWidth: 0.75,
                color: '#f44336'
            },
            BBW: {
                length: 20,
                stddev: 2,
                lineWidth: 0.75,
                color: '#2cc6c9ab'
            },
            CCI: {
                length: 20,
                lineWidth: 0.75,
                color: '#e28a3dee',
                backColor: '#e28a3d11',
                bandColor: '#aaaaaa',
                upper: 100,
                lower: -100
            },
            COG: {
                length: 10,
                lineWidth: 0.75,
                color: '#559de0'
            },
            DMI: {
                length: 14,
                lineWidth: 0.75,
                colors: ["#ef1360", "#3782f2", "#f48709"]
            },
            HMA: {
                length: 9,
                lineWidth: 0.75,
                color: '#3af475'
            },
            KCW: {
                length: 20,
                mult: 1.5,
                lineWidth: 0.75,
                color: '#4c8dffab'
            },
            KC: {
                length: 20,
                mult: 1.5,
                lineWidth: 0.75,
                color: '#4c8dffab',
                showMid: true,
                backColor: '#4c8dff0a'
            },
            MOM: {
                length: 10,
                lineWidth: 0.75,
                color: '#bcc427ee'
            },
            MFI: {
                length: 14,
                lineWidth: 0.75,
                color: '#85c427ee',
                bandColor: '#aaaaaa',
                backColor: '#85c42711',
                upper: 80,
                lower: 20
            },
            Ribbon: {
                start: 10,
                step: 10,
                count: 6,
                lineWidth: 0.75,
                colors: ["#3aaaf4ee"]
            },
            VWMA: {
                length: 20,
                lineWidth: 0.75,
                color: '#db0670'
            },
            SWMA: {
                length: 10,
                lineWidth: 0.75,
                color: '#db0670'
            },
            TSI: {
                long: 25,
                short: 13,
                signal: 13,
                lineWidth: 0.75,
                colors: ["#3bb3e4", "#f7046d"]
            },
            Ichi: {
                CP: 9,
                BP: 26,
                LSP: 52,
                DIZ: 26,
                baseColor: 'brown',
                conversionColor: 'lightblue',
                laggingColor: '#66CC66',
                lineWidth: 0.75,
                baseLineWidth: 0,
                laggingLineWidth: 0
            }
        }
    }
}

export const MultipleIndicatorSettings = {
    multi: {
        sma: [
            { period: 30, color: "#165ba8", lineWidth: 1 }
        ],
        smaobv: [
            { period: 30, color: "#165ba8", lineWidth: 1 }
        ],
        smavolume: [
            { period: 30, color: "#165ba8", lineWidth: 1 }
        ],
        obvvolume: [
            { period: 1, color: "#165ba8", lineWidth: 1 }
        ],
        // volumeobv:[
        //     {period:30,color:"#165ba8",}
        // ],
        wma: [
            { period: 9, color: "#165ba8", lineWidth: 1 },
            { period: 27, color: "#ff7518", lineWidth: 1 },
        ],
        xma: [
            { period: 15, color: "#165ba8", lineWidth: 1 },
            { period: 45, color: "#ff7518", lineWidth: 1 },
            { period: 60, color: "#6f378b", lineWidth: 1 },
        ],
        gxma: [
            { period: 3, color: "#3F91EB", group: "short-term", lineWidth: 1 },
            { period: 5, color: "#3F91EB", group: "short-term", lineWidth: 1 },
            { period: 8, color: "#3F91EB", group: "short-term", lineWidth: 1 },
            { period: 10, color: "#3F91EB", group: "short-term", lineWidth: 1 },
            { period: 12, color: "#3F91EB", group: "short-term", lineWidth: 1 },
            { period: 15, color: "#3F91EB", group: "short-term", lineWidth: 1 },

            { period: 30, color: "#F21425", group: "long-term", lineWidth: 1 },
            { period: 35, color: "#F21425", group: "long-term", lineWidth: 1 },
            { period: 40, color: "#F21425", group: "long-term", lineWidth: 1 },
            { period: 45, color: "#F21425", group: "long-term", lineWidth: 1 },
            { period: 50, color: "#F21425", group: "long-term", lineWidth: 1 },
            { period: 60, color: "#F21425", group: "long-term", lineWidth: 1 },
        ]
    }
}

export const DarvasBoxSettings = {
    darvasBoxSettings: {
        scanType: 'long',
        scanPeriod: 55,
        topConfirmationPeriod: 3,
        bottomConfirmationPeriod: 3,
        percentageRiskBuffer: 2.0,
        limitTotalRisk: {
            isActive: false,
            valuePct: 20.0,
        },
        volumeIncreasedOver: {
            isActive: false,
            percent: 300,
            previousBars: 1,
        },
        inBox: {
            isActive: false,
            type: 'anyBox', // 'anyBox' | '1stBox'
        }

    }
}
export default {
    ChartSettingsDefaults
}